import React , { useState , useEffect  } from "react";
import useAuth from '../../../hooks/useAuth';
import GearSpinner from '../../../components/GearSpinner/GearSpinner';

const FishbowlTraining = ({ active }) => {
    const { user } = useAuth();
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setShowLoader(false);
        },2000);
    },[active])

    if (!active) return null;

    const renderIframe = () => {
        return (
            <React.Fragment>
                <iframe 
                    title="Motor Training" 
                    src="https://scribehow.com/page-embed/Fishbowl_Training__Qwa2p34UT26nMqNXTupikQ" 
                    width="100%" 
                    height="640" 
                    allow="fullscreen" 
                    style={{border:"0", minHeight:"640px"}}>
                </iframe>
            </React.Fragment>
        )
    }
    
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12">
                    <h5>Fishbowl Training</h5>
                    <div className="row mt-5">														
                        <div className="col-md-12">
                            <div className="row g-3">
                                {showLoader && (
                                    <GearSpinner />
                                )}
                                {renderIframe()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        
    )

}

export default FishbowlTraining;